<ng-container *ngIf="modern; else classic">
	<div class="ba-card" [class.ba-card--queued]="assignment.queued">
		<div class="ba-head">
			<div class="ba-head__main">
				<span class="ba-title">{{ 'tx-bde.activeAssignment' | translate }}</span>
				<div class="ba-chips">
					<span class="ba-chip" *ngIf="assignment?.auftrag_start">
						<fa-icon icon="clock"></fa-icon>
						{{ assignment?.auftrag_start | date: 'HH:mm' }} {{ 'general.clock' | translate }}
					</span>
					<span class="ba-chip" *ngIf="assignment?.auftrag_zeit_soll">
						{{ 'tx-bde.targetTime' | translate }}: <b>{{ assignment?.auftrag_zeit_soll }}</b>
					</span>
					<span class="ba-chip" *ngIf="assignment?.auftrag_zeit_ist">
						{{ 'tx-bde.actualTime' | translate }}: <b>{{ assignment?.auftrag_zeit_ist }}</b>
					</span>
				</div>
			</div>
			<div class="ba-status" [class.ba-status--queued]="assignment.queued">
				<fa-icon *ngIf="assignment.queued" icon="cloud-upload-alt"></fa-icon>
				<fa-icon *ngIf="!assignment.queued" icon="check"></fa-icon>
			</div>
		</div>

		<dl class="ba-info">
			<div class="ba-info__row">
				<dt>{{ 'tx-bde.assignment' | translate }}</dt>
				<dd>{{ assignment?.auftrag_name }}</dd>
			</div>
			<div class="ba-info__row">
				<dt>{{ 'tx-bde.task' | translate }}</dt>
				<dd>{{ assignment?.schritt_name }}</dd>
			</div>
		</dl>

		<div class="ba-field">
			<label class="ba-field__label">{{ 'tx-bde.note' | translate }}</label>
			<input class="ba-input" [(ngModel)]="Note" autocomplete="new-password" />
		</div>

		<div class="ba-field">
			<label class="ba-field__label">{{ 'tx-bde.quantity' | translate }}</label>
			<input type="number" class="ba-input" step="0.1" [(ngModel)]="Quantity" />
		</div>

		<button
			class="ba-end-btn"
			(click)="
				this.end.emit({
					aBuchungsart: 'AE',
					aActiveAuftrag: assignment?.auftrag_nummer,
					aActiveSchritt: assignment?.schritt_nummer,
					aIndex: i,
					aKill: true,
					note: Note,
					quantity: Quantity
				});
				this.EndPressed = true
			"
			[disabled]="EndPressed">
			{{ 'tx-bde.endAssignment' | translate }}
		</button>
	</div>
</ng-container>

<ng-template #classic>
	<div class="wrapper" [class.queued]="assignment.queued">
		<div class="grid title">
			<div class="col-6">
				<h4 class="title">{{ 'tx-bde.activeAssignment' | translate }}</h4>
			</div>
			<div class="col-6 timedata">
				<div *ngIf="assignment?.auftrag_start">
					{{ 'tx-bde.startTime' | translate }}: <b>{{ assignment?.auftrag_start | date: 'HH:mm' }}</b> {{ 'general.clock' | translate }}
				</div>
				<div>
					<span *ngIf="assignment?.auftrag_zeit_soll">
						Soll: <b>{{ assignment?.auftrag_zeit_soll }}</b>
					</span>
					<span *ngIf="assignment?.auftrag_zeit_soll && assignment?.auftrag_zeit_ist"> / </span>
					<span *ngIf="assignment?.auftrag_zeit_ist">
						Ist: <b>{{ assignment?.auftrag_zeit_ist }}</b>
					</span>
				</div>
			</div>
		</div>
		<div class="widget-body">
			<div class="grid">
				<div class="col-12">
					<dl class="dl-horizontal">
						<dt>{{ 'tx-bde.assignment' | translate }}:</dt>
						<dd>{{ assignment?.auftrag_name }}</dd>
						<dd class="line-break"></dd>
						<dt>{{ 'tx-bde.task' | translate }}:</dt>
						<dd>{{ assignment?.schritt_name }}</dd>
					</dl>
					<div class="spinner mt-4">
						<fa-icon *ngIf="assignment.queued" icon="cloud-upload-alt" size="3x"></fa-icon>
						<fa-icon *ngIf="!assignment.queued" icon="check" style="color: limegreen" size="3x"></fa-icon>
					</div>
					<dl class="dl-horizontal">
						<dt>{{ 'tx-bde.note' | translate }}:</dt>
						<dd>
							<input class="form-control" [(ngModel)]="Note" autocomplete="new-password" />
						</dd>
					</dl>
					<dl class="dl-horizontal">
						<dt>Menge:</dt>
						<dd>
							<input type="number" class="form-control" step="0.1" [(ngModel)]="Quantity" />
						</dd>
					</dl>
					<div>
						<button
							mat-raised-button color="primary"
							class="btn-block w-full"
							(click)="
								this.end.emit({
									aBuchungsart: 'AE',
									aActiveAuftrag: assignment?.auftrag_nummer,
									aActiveSchritt: assignment?.schritt_nummer,
									aIndex: i,
									aKill: true,
									note: Note,
									quantity: Quantity
								});
								this.EndPressed = true
							"
							[disabled]="EndPressed">
							{{ 'tx-bde.endAssignment' | translate }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
